import { isEmpty } from 'lodash';
import checkImageUrlForProduct from 'commons/checkImageUrlForProduct';
import categoryAngles from 'commons/category-angles.json';

const FABRIC_OPTION_ID = 17;

export const isSelectedFabricInOptions = (product, selectedOptions) => {
  if (!product || isEmpty(selectedOptions)) {
    return true;
  }

  const selectedFabricOption = selectedOptions[FABRIC_OPTION_ID];

  if (!selectedFabricOption) {
    return true;
  }

  const { options = [] } = product;
  let isSelectedFabricAvailable = true;
  const option = options.find(opt => +opt.id === FABRIC_OPTION_ID);

  if (!option) {
    isSelectedFabricAvailable = false;
  }

  const optValue = option.values[0].option_values.find(
    optVal => `${optVal.id}` === `${selectedFabricOption}`
  );

  if (!optValue) {
    isSelectedFabricAvailable = false;
  }

  return isSelectedFabricAvailable;
};

export const getImagesFromSelectedOptions = ({
  selectedOptionsExtended,
  product,
}) => {
  const selectionKeys = Object.keys(selectedOptionsExtended);
  const validOptionTypes = [17, 18, 19, 132];
  let selectedOptionsVariantSku = '';
  const categoryAngle =
    product && product.type && product.type.name
      ? categoryAngles[product.type.name.toLowerCase()]
      : 1;
  selectionKeys.forEach(collectionTypeId => {
    if (validOptionTypes.includes(parseInt(collectionTypeId, 10))) {
      selectedOptionsVariantSku +=
        selectedOptionsExtended[collectionTypeId].value.sku;
    }
  });
  if (selectedOptionsVariantSku) {
    const productImgs = checkImageUrlForProduct(
      product,
      selectedOptionsVariantSku,
      categoryAngle,
      'pdp'
    );
    return productImgs;
  }
  return {};
};

export const getCurrentProductQuantity = ({
  productId = 0,
  orientation = {},
  modularBundleOrderStatus = {},
}) => {
  if (!isEmpty(orientation)) {
    return modularBundleOrderStatus[
      `${productId}-${orientation.currentSelection.id}`
    ]
      ? modularBundleOrderStatus[
          `${productId}-${orientation.currentSelection.id}`
        ].quantity
      : 0;
  }
  return modularBundleOrderStatus[productId]
    ? modularBundleOrderStatus[productId].quantity
    : 0;
};

export const getItemDimensions = ({ attributes }) => {
  const dimensions = {};
  for (const attribute of attributes) {
    if (attribute.code === 'width') {
      dimensions.sizeWidth = attribute.value;
    }
    if (attribute.code === 'height') {
      dimensions.sizeHeight = attribute.value;
    }
    if (attribute.code === 'depth') {
      dimensions.sizeDepth = attribute.value;
    }
  }
  return dimensions;
};

export const MISSING_OPTION_MSG =
  'Sorry, we don’t carry this in your selected upholstery. Please choose another if you need this for your build.';
